import { render, staticRenderFns } from "./MyBoxes.vue?vue&type=template&id=6e657742&scoped=true"
import script from "./MyBoxes.vue?vue&type=script&lang=js"
export * from "./MyBoxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e657742",
  null
  
)

export default component.exports